import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'obtained-specialities';

const ObtainedSpecialityService = {
  getList(diplomaIds) {
    // Build diploma ids
    const queryString = ApiUtil.buildArrayToQueryString('diploma', diplomaIds);

    return Http.get(`/${RESOURCE_NAME}/list?${queryString}`);
  },
};

export default ObtainedSpecialityService;
